import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Upload, Hash } from "lucide-react";
import { Input } from "@/components/ui/input";
import { GlassCard, Field } from "@/components/erp";
import api, { errMsg } from "@/lib/api";

const Satir = ({ b, onKaydet }) => {
  const [onek, setOnek] = useState(b.onek);
  const [sonraki, setSonraki] = useState(Number(b.sonraki.replace(/^\D+/, "")) || 1);
  useEffect(() => { setOnek(b.onek); setSonraki(Number(b.sonraki.slice(b.onek.length)) || 1); }, [b]);
  return (
    <div className="grid grid-cols-12 gap-2 items-end" data-testid={`belge-no-${b.tur}`}>
      <div className="col-span-12 sm:col-span-4 text-sm font-semibold pb-2">{b.ad}<div className="text-[11px] text-muted-foreground font-normal">Sıradaki: <span className="font-mono" data-testid={`belge-no-sonraki-${b.tur}`}>{b.sonraki}</span></div></div>
      <Field label="Önek" className="col-span-4 sm:col-span-2"><Input data-testid={`belge-no-onek-${b.tur}`} value={onek} onChange={(e) => setOnek(e.target.value)} className="bg-white/5 font-mono uppercase" /></Field>
      <Field label="Sıradaki numara" className="col-span-5 sm:col-span-3"><Input data-testid={`belge-no-sayi-${b.tur}`} type="number" min="1" value={sonraki} onChange={(e) => setSonraki(Number(e.target.value))} className="bg-white/5 font-mono" /></Field>
      <button data-testid={`belge-no-kaydet-${b.tur}`} onClick={() => onKaydet({ tur: b.tur, onek, sonraki })} className="col-span-3 h-10 rounded-lg border border-[var(--g1)] text-[var(--g1)] text-xs font-semibold hover:bg-white/5">Kaydet</button>
    </div>
  );
};

export const BelgeNumaralari = () => {
  const [l, setL] = useState([]);
  const [busy, setBusy] = useState(false);
  const yukle = () => api.get("/belge-numaralari").then((r) => setL(r.data));
  useEffect(() => { yukle(); }, []);
  const kaydet = async (b) => { try { setL((await api.put("/belge-numaralari", b)).data); toast.success("Belge numarası güncellendi"); } catch (e) { toast.error(errMsg(e)); } };
  const aktar = async (dosya) => {
    setBusy(true);
    const fd = new FormData(); fd.append("dosya", dosya);
    try {
      const { data } = await api.post("/kolaybi-satis/aktar", fd);
      toast.success(`KolayBi: ${data.aktarilan.siparis} sipariş, ${data.aktarilan.irsaliye} irsaliye, ${data.aktarilan.teklif} proforma arşive aktarıldı`);
      data.atlanan.forEach((a) => toast.warning(`Seri numarası olmayan satır atlandı: ${a}`));
      yukle();
    } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  return (
    <GlassCard className="p-6 space-y-4" data-testid="belge-numaralari">
      <div className="flex items-center gap-2 font-semibold"><Hash className="w-4 h-4" />Satış belge numaraları (KolayBi düzeni)</div>
      {l.map((b) => <Satir key={b.tur} b={b} onKaydet={kaydet} />)}
      <label data-testid="kolaybi-satis-yukle" className="flex items-center gap-3 p-4 rounded-xl border-2 border-dashed border-white/15 hover:bg-white/5 cursor-pointer text-sm">
        <Upload className="w-5 h-5 text-[var(--g1)]" />
        <span className="flex-1">{busy ? "Aktarılıyor…" : "KolayBi satış belgelerini aktar (Alınan Siparişler / Satış İrsaliyeleri / Proformalar Excel dışa aktarımı)"}<span className="block text-[11px] text-muted-foreground">Kayıtlar 'KolayBi Arşivi' olarak listelenir; stok ve cari bakiyeyi etkilemez. Numaralar kaldığı yerden devam eder. Tekrar yüklemek güvenlidir.</span></span>
        <input type="file" accept=".xlsx" className="hidden" data-testid="kolaybi-satis-input" disabled={busy} onChange={(e) => { if (e.target.files[0]) aktar(e.target.files[0]); e.target.value = ""; }} />
      </label>
    </GlassCard>
  );
};
